import { useEffect } from 'react';

export const APP_NAME = 'ادواري';

export function buildTitle(pageTitle) {
  const trimmed = typeof pageTitle === 'string' ? pageTitle.trim() : '';
  return trimmed ? `${trimmed} · ${APP_NAME}` : APP_NAME;
}

// Sets document.title based on the current page. Pass a falsy value
// (e.g. on the home page) to show just the app name.
export default function useDocumentTitle(pageTitle) {
  useEffect(() => {
    document.title = buildTitle(pageTitle);
  }, [pageTitle]);
}
